/**
 * @owner @Appboy/intelligence
 */

import { isRcsEnabled } from "@lib/messageComposition/sms/rcs";
import sharedConstants from "@lib/shared_constants";

import type { RcsImageEligibilityInput } from "./types";

const rcsTypes = sharedConstants.RCS.MESSAGE_TYPES;
const richCardTypes = sharedConstants.RCS.RICH_CARD_TYPES;

/**
 * Whether the message shape can wire an RCS Image component (protocol, subscription
 * group, and message/card type). Ignores media_url — URL format is checked separately.
 */
export const isRcsImageEligibleMessageShape = (message: RcsImageEligibilityInput | null | undefined): boolean => {
  if (!message) {
    return false;
  }
  if (message.protocol !== sharedConstants.SMS_PROTOCOL.RCS) {
    return false;
  }
  if (!isRcsEnabled(message.selected_messaging_service)) {
    return false;
  }

  const rcsMessage = message.rcs_message;
  if (!rcsMessage?.type) {
    return false;
  }

  if (rcsMessage.type === rcsTypes.MEDIA) {
    return true;
  }

  if (rcsMessage.type === rcsTypes.RICH_CARD && rcsMessage.rich_card_type === richCardTypes.MEDIA) {
    return true;
  }

  return false;
};
